import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from "axios";

const Logout = ()=>{
    const navigate = useNavigate();
    
    useEffect(() => {
        document.title = "Logging out..."; // Set the tab name
    }, []);

    const doLogout = async () => {
        try {
            // wait for session unset and session destroy to finish
            await axios.post('https://docuquest-swu.swucite.tech/api_drts/logout.php', {}, { withCredentials: true });

            localStorage.clear();
            sessionStorage.clear();
            navigate('/login');
        } catch (e) {
            console.error("Logout ERROR: ", e);
        }
    }

    useEffect(()=>{
        doLogout();
    }, [navigate]) // ensure that logout only happens once

    return (
        <div className='Logout'>
            <p>Logging out...</p>
        </div>
    )
}

export default Logout;